import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    talonRegistration_title: 'Регистрация талона',
    talonRegistration_columnId: 'ID услугодателя',
    talonRegistration_columnName: 'Наименование услугодателя',
    talonRegistration_columnBin: 'БИН',
    talonRegistration_columnLocality: 'Населенный пункт',
    talonRegistration_columnIsActive: 'Статус',
    talonRegistration_active: 'Активен',
    talonRegistration_inactive: 'Неактивен',
    talonRegistration_registered: 'Зарегистрировано',
    talonRegistration_columnActions: 'Действия',
    talonRegistration_columnLegalAddress: 'Юридический адрес',
    talonRegistration_columnDesignCapacity: 'Проектная мощность',
    talonRegistration_view: 'Просмотр',
    talonRegistration_viewTitle: 'Просмотр талона',
    talonRegistration_register: 'Зарегистрировать',
    talonRegistration_registerSuccess: 'Талон успешно зарегистрирован',
    talonRegistration_registerError: 'Не удалось зарегистрировать талон',
    talonRegistration_errorLoadTable: 'Не удалось загрузить реестр',
    talonRegistration_errorLoadDetail: 'Не удалось загрузить данные талона'
  },
  kk: {
    talonRegistration_title: 'Талонды тіркеу',
    talonRegistration_columnId: 'Қызмет көрсетуші ID',
    talonRegistration_columnName: 'Қызмет көрсетушінің атауы',
    talonRegistration_columnBin: 'БСН',
    talonRegistration_columnLocality: 'Елді мекен',
    talonRegistration_columnIsActive: 'Мәртебесі',
    talonRegistration_active: 'Белсенді',
    talonRegistration_inactive: 'Белсенді емес',
    talonRegistration_registered: 'Тіркелген',
    talonRegistration_columnActions: 'Әрекеттер',
    talonRegistration_columnLegalAddress: 'Заңды мекенжайы',
    talonRegistration_columnDesignCapacity: 'Жобалық қуаты',
    talonRegistration_view: 'Қарау',
    talonRegistration_viewTitle: 'Талонды қарау',
    talonRegistration_register: 'Тіркеу',
    talonRegistration_registerSuccess: 'Талон сәтті тіркелді',
    talonRegistration_registerError: 'Талонды тіркеу мүмкін болмады',
    talonRegistration_errorLoadTable: 'Тізілімді жүктеу мүмкін болмады',
    talonRegistration_errorLoadDetail: 'Талон деректерін жүктеу мүмкін болмады'
  }
});
